export default "__VITE_ASSET__BxocK$Zi__"